(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.drop-pdp').forEach(initDropPdp);
});

function shopifyFormatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '$' + '{' + '{amount}}';

  function defaultOption(opt, def) { return opt == null ? def : opt; }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents2 = parts[1] ? decimal + parts[1] : '';
    return dollars + cents2;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

function initDropPdp(root) {
  const form = root.querySelector('#drop-pdp-form');
  if (!form) return;

  const variants = JSON.parse(root.querySelector('#drop-variants-json').textContent);
  const moneyFormatEl = root.querySelector('#drop-money-format');
  const moneyFormat = moneyFormatEl ? JSON.parse(moneyFormatEl.textContent) : '$' + '{' + '{amount}}';
  const hiddenId = root.querySelector('#drop-variant-id');
  const priceEls = root.querySelectorAll('[data-price]');
  const compareEls = root.querySelectorAll('[data-compare-price]');
  const salePills = root.querySelectorAll('[data-sale-pill]');
  const skuEl = root.querySelector('[data-sku]');
  const stockEl = root.querySelector('[data-stock-label]');
  // FIX: only select the desktop ATC button — sticky bar is handled separately via swipe
  const desktopAtc = root.querySelector('#drop-atc');
  const desktopAtcLabel = desktopAtc ? desktopAtc.querySelector('[data-atc-label]') : null;
  const errorEl = root.querySelector('#drop-error');
  const optionGroups = root.querySelectorAll('.drop-pdp__option');
  const viewer = root.querySelector('#drop-viewer');
  const thumbs = root.querySelector('#drop-thumbs');
  const qtyInput = root.querySelector('#drop-quantity');

  function money(cents) {
    return shopifyFormatMoney(cents, moneyFormat);
  }

  let selected = variants[0] ? variants[0].options.slice() : [];
  optionGroups.forEach((group) => {
    const idx = Number(group.dataset.optionIndex);
    const active = group.querySelector('.drop-pdp__pill--option.is-selected');
    if (active) selected[idx] = active.dataset.value;
  });

  function findVariant(options) {
    return variants.find((v) => v.options.every((val, i) => val === options[i]));
  }

  function refreshAvailability() {
    optionGroups.forEach((group) => {
      const idx = Number(group.dataset.optionIndex);
      group.querySelectorAll('.drop-pdp__pill--option').forEach((pill) => {
        const hypothetical = selected.slice();
        hypothetical[idx] = pill.dataset.value;
        const match = findVariant(hypothetical);
        pill.classList.toggle('is-unavailable', !match || !match.available);
        pill.classList.toggle('is-selected', selected[idx] === pill.dataset.value);
      });
      const nameEl = group.querySelector('[data-selected-value]');
      if (nameEl) nameEl.textContent = selected[idx] || '';
    });
  }

  function updateMedia(variant) {
    if (!variant || !variant.featured_media) return;
    const mediaId = String(variant.featured_media.id);
    if (viewer) {
      viewer.querySelectorAll('.drop-pdp__slide').forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      });
    }
    if (thumbs) {
      thumbs.querySelectorAll('.drop-pdp__thumb').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
    }
  }

  function updateUI() {
    const variant = findVariant(selected);
    refreshAvailability();

    if (!variant) {
      if (desktopAtc) desktopAtc.disabled = true;
      if (desktopAtcLabel) desktopAtcLabel.textContent = 'Unavailable';
      setSwipeState('unavailable');
      if (stockEl) {
        stockEl.textContent = 'Unavailable';
        stockEl.classList.add('is-out');
        stockEl.classList.remove('is-in');
      }
      return;
    }

    hiddenId.value = variant.id;
    priceEls.forEach((el) => (el.textContent = money(variant.price)));

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    compareEls.forEach((el) => {
      if (onSale) {
        el.textContent = money(variant.compare_at_price);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    salePills.forEach((el) => (el.hidden = !onSale));

    if (skuEl) skuEl.textContent = variant.sku || variant.id;
    if (stockEl) {
      stockEl.textContent = variant.available ? 'In stock' : 'Sold out';
      stockEl.classList.toggle('is-in', variant.available);
      stockEl.classList.toggle('is-out', !variant.available);
    }
    if (desktopAtc) desktopAtc.disabled = !variant.available;
    if (desktopAtcLabel) desktopAtcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

    setSwipeState(variant.available ? 'idle' : 'soldout');
    updateMedia(variant);
  }

  optionGroups.forEach((group) => {
    const idx = Number(group.dataset.optionIndex);
    group.querySelectorAll('.drop-pdp__pill--option').forEach((pill) => {
      pill.addEventListener('click', () => {
        if (pill.classList.contains('is-unavailable')) return;
        selected[idx] = pill.dataset.value;
        updateUI();
      });
    });
  });

  if (thumbs) {
    thumbs.querySelectorAll('.drop-pdp__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        viewer.querySelectorAll('.drop-pdp__slide').forEach((slide) => {
          slide.classList.toggle('is-active', slide.dataset.mediaId === thumb.dataset.mediaId);
        });
        thumbs.querySelectorAll('.drop-pdp__thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  root.querySelectorAll('.drop-pdp__step').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(btn.dataset.step));
      qtyInput.value = next;
    });
  });

  const sizeChartDialog = root.querySelector('#drop-size-chart') || document.getElementById('drop-size-chart');

  function activateChartTab(key) {
    if (!sizeChartDialog) return;
    sizeChartDialog.querySelectorAll('[data-chart-tab]').forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.chartTab === key);
    });
    sizeChartDialog.querySelectorAll('[data-chart-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.chartPanel === key);
    });
  }

  root.querySelectorAll('[data-open-size-chart]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!sizeChartDialog) return;
      const hasTshirt = sizeChartDialog.querySelector('[data-chart-panel="tshirt"]');
      const fallback = sizeChartDialog.dataset.defaultChart;
      activateChartTab(hasTshirt ? 'tshirt' : fallback);
      if (sizeChartDialog.showModal) sizeChartDialog.showModal();
    });
  });

  if (sizeChartDialog) {
    sizeChartDialog.querySelectorAll('[data-chart-tab]').forEach((tab) => {
      tab.addEventListener('click', () => activateChartTab(tab.dataset.chartTab));
    });
    sizeChartDialog.querySelectorAll('[data-close-size-chart]').forEach((btn) => {
      btn.addEventListener('click', () => sizeChartDialog.close());
    });
    sizeChartDialog.addEventListener('click', (e) => {
      if (e.target === sizeChartDialog) sizeChartDialog.close();
    });
  }

  // ─── CART ADD (shared fetch logic) ───────────────────────────────────────
  async function addToCart() {
    const variant = findVariant(selected);
    if (!variant || !variant.available) return false;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 }],
        }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || 'Could not add this item to your cart.');
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      return true;
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
      return false;
    }
  }

  // ─── DESKTOP FORM SUBMIT ──────────────────────────────────────────────────
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    const variant = findVariant(selected);
    if (!variant || !variant.available) return;

    if (desktopAtc) desktopAtc.disabled = true;
    if (desktopAtcLabel) desktopAtcLabel.textContent = 'Adding…';

    const ok = await addToCart();

    if (ok) {
      if (desktopAtcLabel) desktopAtcLabel.textContent = 'Added ✓';
      setTimeout(() => {
        if (desktopAtcLabel) desktopAtcLabel.textContent = 'Add to cart';
      }, 1600);
    } else {
      if (desktopAtcLabel) desktopAtcLabel.textContent = 'Add to cart';
    }
    if (desktopAtc) desktopAtc.disabled = !(variant && variant.available);
  });

  // ─── MOBILE 3D ADD BUTTON ─────────────────────────────────────────────────
  const mobileAtc = root.querySelector('[data-mobile-atc]') || document.getElementById('drop-mobile-atc');

  if (mobileAtc) {
    const mobileAtcHome = document.createComment('drop-mobile-atc-home');
    mobileAtc.before(mobileAtcHome);
    const phoneLayout = window.matchMedia('(max-width: 749px)');

    const syncMobileAtcLayout = () => {
      const dockCart = document.querySelector('.product-mobile-dock__cart');
      if (phoneLayout.matches && dockCart) {
        dockCart.before(mobileAtc);
      } else if (mobileAtcHome.parentNode) {
        mobileAtcHome.parentNode.insertBefore(mobileAtc, mobileAtcHome.nextSibling);
      }
    };

    syncMobileAtcLayout();
    phoneLayout.addEventListener?.('change', syncMobileAtcLayout);

    mobileAtc.addEventListener('click', async () => {
      if (mobileAtc.disabled || mobileAtc.dataset.atcState === 'loading') return;
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      setSwipeState('loading');
      const ok = await addToCart();
      setSwipeState(ok ? 'success' : 'idle');
    });
  }

  function setSwipeState(state) {
    if (!mobileAtc) return;
    const label = mobileAtc.querySelector('[data-mobile-atc-label]');
    mobileAtc.dataset.atcState = state;
    mobileAtc.classList.toggle('is-success', state === 'success');

    if (state === 'loading') {
      mobileAtc.disabled = true;
      if (label) label.textContent = 'Adding…';
    } else if (state === 'success') {
      mobileAtc.disabled = false;
      if (label) label.textContent = 'Added to cart';
      window.setTimeout(() => setSwipeState('idle'), 1500);
    } else if (state === 'soldout' || state === 'unavailable') {
      mobileAtc.disabled = true;
      if (label) label.textContent = state === 'soldout' ? 'Sold out' : 'Unavailable';
    } else {
      mobileAtc.disabled = false;
      if (label) label.textContent = 'Add to cart';
    }
  }

  updateUI();
}

  } catch(e) { console.error(e); }
})();
})();
